// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3HDJb","tab":"Tabs_tab__2RNdf","tabActive":"Tabs_tabActive__1N3zx"};